export default __webpack_public_path__ + "static/media/gallery24.d1332007.jpg";